import { Injectable } from '@angular/core';
import { SNACKBAR } from '@domain/constants/snackbar-setting';
import { CarrierVettingService } from '@service/carrier-vetting/carrier-vetting.service';
import { UrlService } from '@service/url/url.service';
import { UtilService } from '@service/util/util.service';
import { RestService } from 'cargo-chief-commons';

@Injectable({
	providedIn: 'root',
})
export class RMISService {
	constructor(
		private urlService: UrlService,
		private restService: RestService,
		private utilService: UtilService,
		private carrierVettingService: CarrierVettingService
	) {}

	inviteCarrier(carrierId: string) {
		const url = this.urlService.inviteRMISCarrier(carrierId);
		this.restService.POST(url, {}).subscribe({
			next: () => {
				this.utilService.showSnackbar(
					'Successfully invited carrier',
					SNACKBAR.SUCCESS,
					SNACKBAR.ACTION
				);
				this.carrierVettingService.carrierInvitationSent(carrierId);
			},
			error: (error) => {
				const message = error['error'] || 'Unable to invite carrier';
				this.utilService.showSnackbar(message, SNACKBAR.ERROR, SNACKBAR.ACTION);
			},
		});
	}
}
